import { IAuthState } from "app/modules/auth";
import {
  selectCookiePreferences,
  setCookiePreferences,
  updateCookiePreferences,
} from "app/system/cookies/CookiePreferencesSlice";
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ClientPortalCookiePreferencesModel } from "services/api/cplauthapi/CPLAuthAPI";
import { IClientPortalCookieService } from "services/ClientPortalCookieService";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { RootState } from "setup/redux/RootReducer";
import { useThunkDispatch } from "setup/redux/thunkDispatch";

const useCookies = () => {
  const cookiesService = container.get<IClientPortalCookieService>(SERVICE_TYPES.ClientPortalCookieService);
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();
  const authState = useSelector<RootState, IAuthState>(({ auth }) => auth, shallowEqual);
  const preferences = useSelector(selectCookiePreferences);

  useEffect(() => {
    const storedCookiePreferences = cookiesService.getLocalCookiePreferences();
    dispatch(setCookiePreferences(storedCookiePreferences));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (authState?.user != undefined) {
      thunkDispatch(updateCookiePreferences());
    }
  }, [authState, thunkDispatch]);

  const setPreferences = (preferences: ClientPortalCookiePreferencesModel) => {
    dispatch(setCookiePreferences(preferences));
    cookiesService.setLocalCookiePreferences(preferences);
    if (authState?.user != undefined) {
      thunkDispatch(updateCookiePreferences());
    }
  };

  return { preferences, setPreferences };
};

export default useCookies;
